import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { useRef } from 'react';
import { Icon } from '../Icon/Icon.js';
import s from './DropdownMenu.module.scss.js';

function DropdownMenu(_ref) {
  let {
    disabled,
    actions,
    dropdownIconFactory,
    iconSize,
    contrast
  } = _ref;
  const menu = useRef(null);
  const onClick = event => {
    var _a;
    (_a = menu.current) === null || _a === void 0 ? void 0 : _a.toggle(event);
  };
  const className = clsx(s.actionButton, contrast ? s.contrast : null);
  const menuClassName = clsx(contrast ? s.contrast : null);
  return actions && actions.length > 0 ? jsxs(Fragment, {
    children: [dropdownIconFactory ? dropdownIconFactory(onClick) : jsx(Button, {
      type: "button",
      onClick: onClick,
      text: true,
      disabled: disabled,
      className: className,
      icon: jsx(Icon, {
        name: "more_vert",
        fontSize: iconSize
      })
    }), jsx(Menu, {
      className: menuClassName,
      model: actions,
      popup: true,
      ref: menu
    })]
  }) : null;
}

export { DropdownMenu };
